import { Address } from "viem"

import { IS_MEZO_MAINNET } from "../network"

const abi = [
  {
    inputs: [],
    name: "depositParameters",
    outputs: [
      {
        internalType: "uint64",
        name: "depositDustThreshold",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "depositTreasuryFeeDivisor",
        type: "uint64",
      },
      {
        internalType: "uint64",
        name: "depositTxMaxFee",
        type: "uint64",
      },
      {
        internalType: "uint32",
        name: "depositRevealAheadPeriod",
        type: "uint32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const

const mainnetAddress = "0x5e4861a80B55f035D899f66772117F00FA0E8e7B"
const sepoliaAddress = "0x9b1a7fE5a16A15F2f9475C5B231750598b113403"

const address: Address = IS_MEZO_MAINNET ? mainnetAddress : sepoliaAddress

export default {
  abi,
  address,
}
